class VideoQuestionStrategy {

    constructor(playScreenController, result) {
        this.playScreenController = playScreenController;
        this.result = result;

        this.mediaContainer = null;
        this.questionContainer = null;

        this.video = null;
        this.arrowUp = null;
        this.arrowDown = null;
        this.progressBar = null;
    }
    
    draw() {

        this.mediaContainer = $('#mediaContainer');
        this.questionContainer = $('#questionContainer');
        this.mediaContainer.slideDown();

        this.preloader = this.playScreenController.createPreloader(customIcons["QUESTION_MULTIMEDIA_VIDEO"]).appendTo(this.mediaContainer);
        this.preload();
    }

    preload() {
        if (!this.result.own_poll) {
            this.questionContainer.css('background-color', '#' + this.playScreenController.currentQuestion.category.color);
            $(".question-color-wrapper").css("background-color", hex2rgba(this.playScreenController.currentQuestion.category.color, 0.75));
        }
        this.questionContainer.css('min-height', 'calc(100% - 185px)');
        const mainContainer = $('#mainContainer');
        mainContainer.css('overflow', 'auto');
        $(".question-color-wrapper").show();
        this._preloadTimeout = setTimeout(this.load.bind(this), this.result.poll_end_resume ? 750 : 1500);
    }

    load() {
        const that = this;
        const darkColor = this.result.own_poll ? this.result.own_poll.dark_color : this.playScreenController.currentQuestion.category.dark_color;

        this.arrowUp = $('<div>', {
            'class': 'media-arrow text-center',
            'html': '<i id="textUp" class="fa fa-angle-down fa-3x displayImgArrow" aria-hidden="true"></i>',
            'css': {
                'cursor': 'pointer',
                'color': '#' + darkColor,
                'position': 'relative'
            }
        }).prependTo(this.questionContainer);

        this.arrowDown = $('<div>', {
            'class': 'media-arrow text-center',
            'html': '<i id="textUp" class="fa fa-angle-up fa-3x displayImgArrow" aria-hidden="true"></i>',
            'css': {
                'cursor': 'pointer',
                'color': '#' + darkColor,
                'position': 'relative'
            }
        }).prependTo(this.questionContainer);
        
        //Use this structure: <video><source></video> to prevent crash on Safari.
        this.video = $('<video>', {
            'class': 'img-responsive',
            'css': {
                'width': '100%'
            },
            'preload': false,
            'muted': true,
            'autoplay': true,
            'playsinline': true,
            'controls': true,
        }).appendTo(this.mediaContainer);

        this.video.on('canplaythrough error', () => {
            this.preloader.hide();
        });

        // Safety timeout
        this._safetyTimeout = setTimeout(() => {
            this.preloader.hide();
        }, 5000);

        this.video.append('<source src="' + this.playScreenController.currentQuestion.multimedia +'">');

        this.progressBar = $('<div>', {
            'class': 'multimedia-progress-bar',
            'html': '<div>'
        }).appendTo(this.mediaContainer);

        // Configurar componentes
        this.arrowUp.hide();
        this.video.bind('contextmenu', function() { return false; });
        this.hideAnswerButtonTexts();
        // Eventos para los componentes
        if (!this.result.poll_end_resume) {
            this.video[0].play();
            this.video.on('ended', this.startTime.bind(this));
        } else {
            $('video').bind('loadedmetadata', function () {
                calculateMediaContentSize(this, 'video');
                that.startTime();
            });
        }
        this.arrowDown.on('click', this.startTime.bind(this));
        this.arrowUp.on('click', this.showVideo.bind(this));
        // Start progress bar
        this.video.on('durationchange', () => {
            let duration = this.video[0].duration * 1000;
            $('.multimedia-progress-bar div').animate({
                'width': '100%'
            }, duration, 'linear');
        });

        this.video.on('canplaythrough', () => {
            this.preloader.hide();
        });

        $('body').addClass('stop-scrolling');

        $('video').bind('loadedmetadata', function () {
            calculateMediaContentSize(this, 'video');
        });
    }

    startTime() {
        this.video.off('ended');
        this.arrowDown.off('click');
        this.arrowDown.on('click', this.hideVideo.bind(this));

        this.video[0].controls = true;
        this.video[0].currentTime = 0;
        this.video[0].pause();

        this.hideVideo();
        $(".question-color-wrapper").hide();
        this.showAnswerButtonTexts();
        this.progressBar.hide();

        if (!this.result.own_poll) {
            this.playScreenController.startTimer(this.result);
        } else {
            this.playScreenController.startTimerPoll(this.result);
        }
    }

    hideVideo() {
        if(this.preloader) {
            this.preloader.hide();
        }
        this.video[0].pause();
        this.mediaContainer.slideUp();
        this.arrowUp.show();
        this.arrowDown.hide();
        $('body').removeClass('stop-scrolling');
    }

    showVideo() {
        this.mediaContainer.slideDown();
        this.arrowUp.hide();
        this.arrowDown.show();
        $('body').addClass('stop-scrolling');
    }

    hideAnswerButtonTexts() {
        $('.answerBtn').each(function(i, elem) {
            elem = $(elem);
            elem.text(' ');
        });
    }

    showAnswerButtonTexts() {
        $('.answerBtn').each(function(i, elem) {
            elem = $(elem);
            elem.text(elem.attr('data-answer'));
        });
    }

    cancel() {
        clearTimeout(this._preloadTimeout);
        clearTimeout(this._safetyTimeout);
        if (this.video) {
            this.video.off('ended canplaythrough');
            this.video[0].pause();
        }
    }

    onCompleteTime() {
        // console.trace('onCompleteTime');
        try {
            if (!document.fullscreenElement &&    // alternative standard method
                !document.mozFullScreenElement &&
                !document.webkitFullscreenElement &&
                !document.msFullscreenElement
            ) {  // current working methods
                if (document.documentElement.requestFullscreen) {
                    // console.trace(document.documentElement.requestFullscreen);
                    document.documentElement.requestFullscreen();
                } else if (document.documentElement.msRequestFullscreen) {
                    document.documentElement.msRequestFullscreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullscreen) {
                    document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                }
            }
        }catch (e) {
            console.trace('error', e);
            document.exitFullscreen();
        }
    }

}